import { useEffect, useRef, useState } from 'react';

/**
 * Counts down from `seconds` while `active` is true and calls `onDone` once when it reaches zero. Going inactive
 * (cancelled) stops it without calling anything; going active again starts over. Returns the seconds left.
 */
export function useCountdown({ active, seconds, onDone }) {
    const [left, setLeft] = useState(seconds);
    const onDoneRef = useRef(onDone);
    onDoneRef.current = onDone;

    useEffect(() => {
        if (!active) { return undefined; }
        setLeft(seconds);
        let remaining = seconds;
        const timer = setInterval(() => {
            remaining -= 1;
            setLeft(remaining);
            if (remaining <= 0) {
                clearInterval(timer);
                onDoneRef.current?.();
            }
        }, 1000);
        return () => clearInterval(timer);
    }, [active, seconds]);

    return left;
}
